export function isIE() {
    return Boolean(document.documentMode);
}
export function isChromium() {
    return !!window.chrome || /HeadlessChrome/.test(window.navigator.userAgent);
}
//# sourceMappingURL=browserDetection.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-core/esm/tools/utils/browserDetection.js
// module id = null
// module chunks = 